import { AutocompleteValue } from '@freighthub/silhouette-core'

import { IApiService } from './ApiService'

type TAutocompleteFilter<T> = (results: T) => T
export type TAutocomplete<T> = (query: string, filter?: TAutocompleteFilter<T>) => Promise<AutocompleteValue[]>
type TAutocompleteParams = (params: object) => Promise<AutocompleteValue[]>

export interface IAutocompleteService<T> {
  autocompleteProcess: (json: T) => AutocompleteValue[]
  autocomplete?: TAutocomplete<T>
  autocompleteParams?: TAutocompleteParams
  autocompleteEndpoint?: string
}

export function autocomplete<T>(
  this: IApiService & IAutocompleteService<T>,
  query: string,
  filter?: (results: T) => T
): Promise<AutocompleteValue[]> {
  // @ts-expect-error TS(2345) FIXME: Argument of type '(results: T) => Promise<Autocomp... Remove this comment to see the full error message
  return this.httpAPI.get(this.autocompleteEndpoint || this.endpoint, { params: { query } }).then((results: T) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    return this.autocompleteProcess(filter ? filter(results) : results) as any as Promise<AutocompleteValue[]>
  })
}
